"use client"

import { ArrowRight, Moon, Sun } from "lucide-react"
import { Mascot } from "@/components/marketing/landing-v2/Mascot"
import type { Landing2Copy, Landing2Locale } from "@/lib/landing-v2/copy"
import { PERSIAN_HOME_PATH } from "@/lib/marketing-locale"

type Landing2HeaderProps = {
  copy: Landing2Copy
  locale: Landing2Locale
  onLocaleChange: (locale: Landing2Locale) => void
  theme: "dark" | "light"
  onThemeToggle: () => void
  onCta: () => void
}

export function Landing2Header({
  copy,
  locale,
  onLocaleChange,
  theme,
  onThemeToggle,
  onCta,
}: Landing2HeaderProps) {
  return (
    <header className="l2-header">
      <div className="l2-header-inner">
        <a className="l2-wordmark" href="#top">
          <Mascot size={30} priority />
          <span>atirame</span>
        </a>

        <div className="l2-header-actions">
          <nav className="l2-lang" aria-label={copy.nav.language}>
            <button
              type="button"
              onClick={() => onLocaleChange("en")}
              aria-current={locale === "en" ? "true" : undefined}
            >
              EN
            </button>
            <button
              type="button"
              onClick={() => onLocaleChange("hy")}
              aria-current={locale === "hy" ? "true" : undefined}
            >
              HY
            </button>
            <a href={PERSIAN_HOME_PATH} title={copy.nav.persianSite}>
              FA
            </a>
          </nav>

          <button
            type="button"
            className="l2-icon-button"
            onClick={onThemeToggle}
            aria-label={theme === "dark" ? copy.nav.toLight : copy.nav.toDark}
          >
            {theme === "dark" ? (
              <Sun size={15} strokeWidth={1.9} />
            ) : (
              <Moon size={15} strokeWidth={1.9} />
            )}
          </button>

          <button type="button" className="l2-button l2-button-sm" onClick={onCta}>
            <span className="l2-cta-full">{copy.nav.cta}</span>
            <span className="l2-cta-short">{copy.nav.ctaShort}</span>
            <ArrowRight size={14} strokeWidth={2.2} />
          </button>
        </div>
      </div>
    </header>
  )
}
